import React from 'react';
import { FadeIn } from './ui/FadeIn';

const services = [
  {
    label: "LEAD LIST BUILDING",
    title: "Targeted B2B Lead Lists, Built by Hand",
    body: "You tell me who you want to reach, industry, job title, company size, geography, and I build a verified prospect list from scratch. Every lead is manually researched using LinkedIn Sales Navigator and premium tools. Every email is validated. Bounce rate stays under 2%. Delivered in Excel, CSV, or Google Sheets, ready to import into your CRM.",
    bestFor: "Founders and sales teams who need qualified contacts for cold email, outbound sales, or ABM campaigns.",
    format: "Async. Typical delivery 1–5 days depending on list size.",
    deliverable: "Verified lead list (name, title, email, phone, LinkedIn, company details).",
    cta: "→ Request a list",
    link: "#book"
  },
  {
    label: "CLARITY CALL",
    title: "The 60-Minute Diagnosis",
    body: "A single, focused working session. Bring one specific problem, a campaign that isn't converting, a list you're not sure about, a message that feels off, and we fix it in real time. You leave with a written summary, a prioritized action list, and the honest answer to the question most agencies won't give you: is this worth doing at all?",
    bestFor: "Founders who already run outbound and need a second set of experienced eyes.",
    format: "60 minutes, live on Zoom, recorded.",
    deliverable: "Written summary within 24 hours.",
    cta: "→ Book a clarity call",
    link: "#book"
  },
  {
    label: "ICP & OFFER SPRINT",
    title: "Rebuild the Target, Rebuild the Message",
    body: "Two weeks. We tear down who you think you're selling to and rebuild it from evidence, real customer interviews, real deal data, real language from real buyers. Then we rewrite the offer so it's impossible to confuse with your five nearest competitors. This is the work every agency skips. It's also the reason their campaigns fail.",
    bestFor: "Companies about to invest in outbound and wanting to get the foundation right.",
    format: "Two weeks, 3 working sessions, asynchronous work in between.",
    deliverable: "ICP document, messaging map, and offer rewrite.",
    cta: "→ Start a sprint",
    link: "#book"
  },
  {
    label: "OUTBOUND AUDIT",
    title: "A Full, Honest Review of Your Outbound System",
    body: "You send me your sequences, your lists, your targeting logic, your sending infrastructure, and your last 90 days of reply data. I send back a report that reads like an investigative feature. What's working, what's quietly broken, and exactly what to change first. No template checklists. No AI-generated filler. Written by hand, the way I've written for 20 years.",
    bestFor: "Teams with existing outbound operations that have plateaued or declined.",
    format: "One week, fully asynchronous.",
    deliverable: "15–25 page written report, plus a 45-minute walkthrough call.",
    cta: "→ Request an audit",
    link: "#book"
  },
  {
    label: "FRACTIONAL ADVISOR",
    title: "On-Call Strategic Guidance, Monthly",
    body: "For founders who don't need another agency. They need a sharp outside brain on retainer. We meet twice a month, I'm reachable for async questions between sessions, and I review anything you're about to send before it goes out. Limited to 4 clients at a time. Waitlist usually applies.",
    bestFor: "Founders scaling past the first million in revenue who want a veteran thinking alongside them.",
    format: "Monthly retainer, minimum three months.",
    deliverable: "Ongoing strategic input.",
    cta: "→ Apply for a seat",
    link: "#book"
  }
];

export function Services() {
  return (
    <section id="services" className="py-section-mob md:py-section-desk bg-fog">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-12 md:mb-20"> Ways we can work together </h2>
        </FadeIn>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[1px] bg-hairline border border-hairline">
          {services.map((service, idx) => (
            <FadeIn key={idx} delay={idx * 0.1} className="h-full">
              <div className="group h-full bg-paper p-8 md:p-10 transition-colors duration-300 hover:bg-ink/[0.02] flex flex-col">
                <p className="font-mono text-caption text-graphite uppercase mb-6"> {service.label} </p>
                <h3 className="font-heading text-h3-desk text-ink mb-4"> {service.title} </h3>
                <p className="font-body text-body-base text-ink mb-8 flex-grow"> {service.body} </p>
                <div className="space-y-3 mb-10 font-body text-[15px]">
                  <p><span className="text-graphite">Best for:</span> <span className="italic text-ink">{service.bestFor}</span></p>
                  <p><span className="text-graphite">Format:</span> <span className="text-ink">{service.format}</span></p>
                  <p><span className="text-graphite">Deliverable:</span> <span className="text-ink">{service.deliverable}</span></p>
                </div>
                <div className="mt-auto">
                  <a href={service.link} className="inline-flex items-center font-body text-[15px] font-medium text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm" > <span className="animated-underline group-hover:text-ink">{service.cta}</span> </a>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}